<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card">
					<div class="card-header">
						Editando tarea
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body">
						<editor-tarea @actualizar="emiteActualizar($event)" :tarea="tarea" index="0"></editor-tarea>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

import Tarea from '../nueva/tarea'

export default {
	props: ['tarea'],
	name: 'editando-tarea',
	components: {
		'editor-tarea': Tarea
	},
	created: function () {

	},
	methods: {
		cerrar () {
			this.$emit('cerrar')
		},
		emiteActualizar (eliminada) {
			this.$emit('actualizar', eliminada)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/editando-tarea.vue